
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {PRControlTypes} from "../PRControlFactory";


export class QRControlOptions extends PDFControlBaseOptions{
    @observable
    Type:string;
    Text:string;
    Size:number;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=PRControlTypes [PRControlTypes.QRCode];
        this.Text='Put your code here';
        this.Size=3;

    }
}


